import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ErrorMessage from './ErrorMessage';
import useFormControl from './useFormControl';
import { normalizePortalText } from 'utils/baochauTheme';
import './style.scss';

const FormCheckbox = ({
  field,
  label,
  validation,
  disabled = false,
  readOnly = false,
  className,
  checkedValue = 1,
  uncheckedValue = 0,
  onChange,
  id,
  'aria-describedby': ariaDescribedBy,
}) => {
  const { describedBy, error, errorId, fieldValue, hasError, inputId, setFieldValue } = useFormControl({
    field,
    validation,
    id,
    ariaDescribedBy,
  });
  const checked = String(fieldValue) === String(checkedValue);

  return (
    <>
      <label className={classNames('bw_checkbox bw_form_checkbox', className, { 'is-disabled': disabled || readOnly })}>
        <input
          id={inputId}
          type='checkbox'
          name={field}
          data-field={field}
          checked={checked}
          disabled={disabled || readOnly}
          aria-invalid={hasError || undefined}
          aria-describedby={describedBy}
          onChange={(event) => {
            const nextValue = event.target.checked ? checkedValue : uncheckedValue;
            setFieldValue(nextValue);
            onChange?.(nextValue, event);
          }}
        />
        <span aria-hidden='true' />
        {typeof label === 'string' ? normalizePortalText(label) : label}
      </label>
      {error ? <ErrorMessage id={errorId} message={error.message} /> : null}
    </>
  );
};

FormCheckbox.propTypes = {
  field: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  validation: PropTypes.object,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  className: PropTypes.string,
  checkedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  uncheckedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  id: PropTypes.string,
};

export default FormCheckbox;
